import { render, staticRenderFns } from "./ANewGrado.vue?vue&type=template&id=15e28a1e"
import script from "./ANewGrado.vue?vue&type=script&lang=js"
export * from "./ANewGrado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports